import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableFooter from '@material-ui/core/TableFooter';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import RefreshIcon from '@material-ui/icons/Autorenew';
import VolumeOffIcon from '@material-ui/icons/VolumeOff';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { TABLE_HEADER_COLOR, WEARABLE_ALARM_TYPES_MAP } from '../../_config/consts';
import { getColorFromThemeName } from '../../_config/utils';
import { WEARABLE_ALARMS_STATUS, WEARABLE_ALARMS_STATUS_MAP } from '../../_config/consts';
import SelectMultipleCheckBoxIconCustom from '../CustomIcons/SelectMultipleCheckBoxIconCustom.jsx';
import EmptyView from '../EmptyView.jsx';
import ListLoadingView from '../ListLoadingView.jsx';
import MDTablePaginationActions from '../MDTable/MDTablePaginationActions.jsx';

const styles = theme => ({
  table: {
    overflow: 'scroll',
  },
  tableColumnText: {
    fontWeight: 'bold',
    color: '#3f3f3f',
  },
  disabledInput: {
    display: 'none',
  },
  rowHovered: {
    cursor: 'pointer',
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
    minHeight: 80,
  },
  actionContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  rowContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  paginationText: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#3f3f3f',
  },
  button: {
    color: '#4caf50',
    fontSize: 13,
    fontWeight: 'bold',
    textDecoration: 'underline',
    width: 'max-content',
  },
  statusBadge: {
    padding: '4px 8px',
    borderRadius: 4,
    fontSize: 15,
    fontWeight: 'bold',
    display: 'inline-block',
  },
});

@connect((state) => ({ 
  viewLoading: state.utils.viewLoading, 
  wearables: state.wearables, 
  themeName: state.settings.items.theme.data.themeName 
}))
class WearableAlarmsTableView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      selectionModeActive: false,
      selectedAllActive: false,
      selectedRows: [],
    };
  }

  onToggleTableSelection() {
    const { selectionModeActive, selectedRows, selectedAllActive } = this.state;
    const selection = !selectionModeActive ? selectedRows : [];
    const selectAllValue = !selectionModeActive ? selectedAllActive : false;
    this.setState({ selectionModeActive: !selectionModeActive, selectedRows: selection, selectedAllActive: selectAllValue });
  }

  onToggleRowSelection(isSelected, alarm) {
    const { selectedRows } = this.state;
    const newSelection = selectedRows;
    if (!isSelected) {
      newSelection.push(alarm);
    } else {
      const index = _.findIndex(newSelection, existingAlarm => existingAlarm.id === alarm.id);
      _.pullAt(newSelection, index);
    }
    this.setState({ selectedRows: newSelection });
  }

  onSelectAll(isSelected) {
    const { selectedRows } = this.state;
    let newSelection = selectedRows;
    if (!isSelected) {
      const { wearables: { alarms: { content: alarmsData } } } = this.props;
      newSelection = _.clone(alarmsData.filter(alarm => alarm.status === WEARABLE_ALARMS_STATUS.ACTIVE));
    } else {
      newSelection = [];
    }
    this.setState({ selectedRows: newSelection, selectedAllActive: !isSelected });
  }

  onSilenceAlarmsBatch(alarms) {
    const { onSilenceAlarmsBatch } = this.props;
    this.setState({ selectedRows: [], selectionModeActive: false });
    onSilenceAlarmsBatch(alarms);
  }

  render() {
    const {
      classes,
      viewLoading,
      themeName,
      wearables: { alarms: { content: alarmsData, pagination: { number: currentPage, size, totalPages, totalElements } }},
      onRefreshWearableAlarms,
      onFetchWearableAlarmsOnPage,
      onSilenceAlarm,
    } = this.props;
    const { selectionModeActive, selectedAllActive, selectedRows } = this.state;
    return (
      <div className="list-view details-section" style={{ top: 190, paddingBottom: 140, width: '87%' }}>
        <div>
          {!_.isEmpty(alarmsData) ?
            <Card style={{ overflow: 'scroll' }} elevation={4}>
              <Table size="small" className={classes.table}>
                <TableHead>
                  <TableRow style={{ backgroundColor: TABLE_HEADER_COLOR }}>
                    <TableCell colSpan={selectionModeActive ? 5 : 4}>
                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <h3 className={classes.tableColumnText} style={{ color: '#3f3f3f', marginTop: 15, marginBottom: 15 }}><Entity entity="wearableAlarms" /></h3>
                        <IconButton onClick={() => onRefreshWearableAlarms()} style={{ marginLeft: 10, marginTop: 5 }}>
                          <RefreshIcon style={{ color: '#3f3f3f', fontSize: 25 }} />
                        </IconButton>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <IconButton onClick={() => this.onToggleTableSelection()} style={{ marginTop: 5 }}>
                            <SelectMultipleCheckBoxIconCustom style={{ color: '#3f3f3f', width: 24 }} />
                          </IconButton>
                          {selectionModeActive && !_.isEmpty(selectedRows) ? (
                            <div style={{ marginLeft: 8, display: 'flex', alignItems: 'center', marginTop: 3 }}>
                              <IconButton onClick={() => this.onSilenceAlarmsBatch(selectedRows)}>
                                <VolumeOffIcon style={{ color: '#4caf50', fontSize: 25 }} />
                              </IconButton>
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </TableCell>
                    <TablePagination
                      colSpan={0}
                      count={!_.isUndefined(totalElements) ? totalElements : 0}
                      rowsPerPage={!_.isUndefined(size) ? size : 0}
                      page={!_.isUndefined(currentPage) ? currentPage : 0}
                      labelRowsPerPage=" "
                      classes={{
                        input: classes.disabledInput,
                      }}
                      labelDisplayedRows={({ from, to, count }) => (
                        <h4 className={classes.paginationText}>
                          <Entity
                            key={`${from}-${totalPages}-${count}`}
                            entity="alarmsTablePagination"
                            data={{
                              currentPage: !_.isUndefined(currentPage) ? currentPage + 1 : 0,
                              totalPages: !_.isUndefined(totalPages) ? totalPages : 0,
                              count: !_.isUndefined(count) ? count : 0,
                            }}
                          />
                        </h4>
                      )}
                      onChangePage={(event, page) => onFetchWearableAlarmsOnPage(page)}
                      ActionsComponent={() => (
                        <MDTablePaginationActions
                          count={totalElements}
                          iconColor="#3f3f3f"
                          page={currentPage}
                          lastPage={totalPages - 1}
                          rowsPerPage={size}
                          onChangePage={(event, page) => onFetchWearableAlarmsOnPage(page)}
                        />
                      )}
                    />
                    </TableRow>
                  <TableRow style={{ backgroundColor: 'white' }}>
                    {selectionModeActive ? (
                      <TableCell padding="checkbox">
                        <Checkbox classes={{root: 'custom-checkbox-root'}} color="primary" checked={selectedAllActive} onChange={checked => this.onSelectAll(selectedAllActive)} />
                      </TableCell>
                    ) : null}
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="wearableDevice" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="user" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="alarmType" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="status" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="alarmCreatedAt" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="lastUpdate" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="actions" /></h4></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {_.map(alarmsData, (alarm) => {
                    const statusConfig = WEARABLE_ALARMS_STATUS_MAP[alarm.status] || {};
                    const canSilence = alarm.status === WEARABLE_ALARMS_STATUS.ACTIVE;
                    const isRowSelected = _.findIndex(selectedRows, selectedAlarm => selectedAlarm.id === alarm.id) >= 0;

                    const alarmTypeConfig = WEARABLE_ALARM_TYPES_MAP[alarm.type] || {};
                    const alarmTypeLabel = alarmTypeConfig.label || alarm.type;
                    return (
                      <TableRow
                        key={alarm.id}
                        className={classes.row}
                        hover
                        classes={{
                          hover: classes.rowHovered,
                        }}
                        onClick={selectionModeActive && canSilence ? () => this.onToggleRowSelection(isRowSelected, alarm) : undefined}
                      >
                        {selectionModeActive ? (
                          <TableCell padding="checkbox">
                            <Checkbox 
                              classes={{root: 'custom-checkbox-root'}} 
                              color="primary" 
                              style={{opacity: canSilence ? 1 : 0, pointerEvents: canSilence ? 'unset' : 'none'}} 
                              checked={isRowSelected} 
                              onChange={() => {this.onToggleRowSelection(isRowSelected, alarm)}} 
                            />
                          </TableCell>
                        ) : null}
                        <TableCell>
                          <div className={classes.rowContainer} style={{ marginTop: 15, marginBottom: 15, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            {alarm.wearable ? (
                              <>
                                <h5 style={{ fontWeight: 'bold', lineHeight: '1.5', fontSize: 14, }}>{alarm.wearable.deviceId}</h5>
                                {alarm.wearable.model ? <h5 style={{ fontSize: 12, margin: 0, color: '#757575' }}>{alarm.wearable.model}</h5> : null}
                              </>
                            ) : (
                              <h5 style={{ color: '#757575' }}><Entity entity="notAvailable" /></h5>
                            )}
                          </div>
                        </TableCell>
                        <TableCell>
                          <div className={classes.rowContainer} style={{ display: 'flex', alignItems: 'center' }}>
                            {alarm.wearable && alarm.wearable.user ? (
                              <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <h5 style={{ fontWeight: 'bold', fontSize: 14 }}>{`${alarm.wearable.user.firstname} ${alarm.wearable.user.lastname}`}</h5>
                                <h5 style={{ marginTop: 0, fontSize: 13 }}>{alarm.wearable.user.email}</h5>
                              </div>
                            ) : (
                              <h5 style={{ color: '#757575' }}><Entity entity="notAssigned" /></h5>
                            )}
                          </div>
                        </TableCell>
                        <TableCell>
                          <div className={classes.rowContainer}>
                            <span 
                              className={classes.statusBadge}
                              style={{ 
                                color: alarmTypeConfig.color,
                                backgroundColor: alarmTypeConfig.backgroundColor 
                              }}
                            >
                              <Entity entity={alarmTypeLabel} />
                            </span>
                          </div>
                        </TableCell>
                        <TableCell>
                          <div className={classes.rowContainer}>
                            <span 
                              className={classes.statusBadge}
                              style={{ 
                                color: statusConfig.color,
                                backgroundColor: statusConfig.backgroundColor 
                              }}
                            >
                              <Entity entity={statusConfig.label} />
                            </span>
                          </div>
                        </TableCell>
                        <TableCell>
                          <div className={classes.rowContainer} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <h5 style={{ fontSize: 14, margin: 0 }}>{moment(alarm.createdAt).format('LL')} - {moment(alarm.createdAt).format('LT')} ({moment(alarm.createdAt).fromNow()})</h5>
                          </div>
                        </TableCell>
                        <TableCell>
                          <div className={classes.rowContainer} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <h5 style={{ fontSize: 14, margin: 0 }}>{moment(alarm.lastUpdateTimestamp).format('LL')} - {moment(alarm.lastUpdateTimestamp).format('LT')} ({moment(alarm.lastUpdateTimestamp).fromNow()})</h5>
                          </div>
                        </TableCell>
                        <TableCell>
                            {canSilence ? (
                              <Button
                                onClick={(event) => {
                                  event.stopPropagation();
                                  onSilenceAlarm(alarm.id);
                                }}
                                className={classes.button}
                              >
                                <Entity entity="silence" />
                                <VolumeOffIcon style={{ fontSize: 15, marginLeft: 5 }} />
                              </Button>
                            ) : (
                              <span style={{ color: '#757575', fontSize: 14 }}>---</span>
                            )}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
                <TableFooter>
                  <TableRow style={{ backgroundColor: TABLE_HEADER_COLOR }}>
                    <TablePagination
                      colSpan={0}
                      count={!_.isUndefined(totalElements) ? totalElements : 0}
                      rowsPerPage={!_.isUndefined(size) ? size : 0}
                      page={!_.isUndefined(currentPage) ? currentPage : 0}
                      labelRowsPerPage=" "
                      classes={{
                        input: classes.disabledInput,
                      }}
                      labelDisplayedRows={({ from, to, count }) => (
                        <h4 className={classes.paginationText}>
                          <Entity
                            key={`${from}-${totalPages}-${count}`}
                            entity="alarmsTablePagination"
                            data={{
                              currentPage: !_.isUndefined(currentPage) ? currentPage + 1 : 0,
                              totalPages: !_.isUndefined(totalPages) ? totalPages : 0,
                              count: !_.isUndefined(count) ? count : 0,
                            }}
                          />
                        </h4>
                      )}
                      onChangePage={(event, page) => onFetchWearableAlarmsOnPage(page)}
                      ActionsComponent={() => (
                        <MDTablePaginationActions
                          count={totalElements}
                          page={currentPage}
                          iconColor="#3f3f3f"
                          lastPage={totalPages - 1}
                          rowsPerPage={size}
                          onChangePage={(event, page) => onFetchWearableAlarmsOnPage(page)}
                        />
                      )}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </Card>
            : (
              <div>
                {!viewLoading ? (
                  <EmptyView
                    title="noWearableAlarms"
                    subtitle="noWearableAlarmsSubtitle"
                    iconName="icon-simple-line-icons-bell"
                  />) : <ListLoadingView />}
              </div>
            )}
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(WearableAlarmsTableView);
